const REACT = '#74daff';
const JS = '#f0e333';
const MACHINE_LEARNING = '#3869f0';
const GATSBY = '#792dc5';
const GRAPHQL = '#df36c3';
const FIREBASE = '#f09138';
const REACT_NATIVE = '#36c0df';

export const BG_COLORS = [
    { key: "React", color: REACT},
    { key: "JS", color: JS},
    { key: "Machine Learning", color: MACHINE_LEARNING},
    { key: "Gatsby", color: GATSBY},
    { key: "GraphQL", color: GRAPHQL},
    { key: "Firebase", color: FIREBASE},
    { key: "React Native", value: REACT_NATIVE}
]